module.exports = __webpack_public_path__ + "static/media/plus.b56f6f6a.png";